<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import { BaseInput, BaseButton, BaseIcon } from "@/components";
import axios from "axios";

export default {
  name: "Login",
  components: {
    BaseInput,
    BaseButton,
    BaseIcon,
  },
  data() {
    return {
      username: "",
      password: "",
      isLoading: false,
    };
  },
  methods: {
    ...mapActions(["login"]),
    signIn() {
      if (this.inputsAreIsValid) {
        this.isLoading = true;
        let $this = this;
        axios
          .get("/version.txt", {
            headers: {
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
            },
          })
          .then(function (response) {
            let version = String(response.data);
            let getLocalVersion = localStorage.getItem("version-checker");
            if (getLocalVersion == null || getLocalVersion == undefined) {
              localStorage.setItem("version-checker", version);
            } else if (version == getLocalVersion) {
              Vue.prototype.$toast.success("Uygulamanız günceldir.");
            } else {
              let timeleft = 3;
              localStorage.removeItem("veri-dagitim-token");
              localStorage.removeItem("refreshToken");
              localStorage.removeItem("expirationDate");
              localStorage.removeItem("userType");
              localStorage.removeItem("userId");
              localStorage.removeItem("cusNo");
              localStorage.removeItem("username");
              localStorage.removeItem("userNumber");

              localStorage.setItem("version-checker", version);
              let refreshTimer = setInterval(function () {
                if (timeleft <= 0) {
                  clearInterval(refreshTimer);
                  Vue.prototype.$toast.success(
                    "Güncelleme tamamlandı. Yeniden başlatılıyor.."
                  );
                  setTimeout(() => {
                    $this.$router.push({ name: "Login" }).then(() => {
                      location.reload(true);
                    });
                  }, 1000);
                } else {
                  Vue.prototype.$toast.warning(
                    "Site güncelleniyor.. " + timeleft + " saniye kaldı."
                  );
                }
                timeleft -= 1;
              }, 1000);
            }
          })
          .then(() => {
            this.login({
              userName: this.username,
              password: this.password,
            }).then(() => {
              this.isLoading = false;
            });
          });
      }
    },
    showModal() {
      this.$modal.show("forgot-password");
    },
    closeModal() {
      this.$modal.hide("forgot-password");
    },
  },
  computed: {
    ...mapGetters(["getErrorMsg"]),
    inputsAreIsValid() {
      return this.username.length > 2 && this.password.length > 2;
    },
  },
  mounted() {
    localStorage.removeItem("esube");
    localStorage.removeItem("userNumber");
    localStorage.removeItem("userId");
  },
};
</script>

<template>
  <div class="login-page">
    <modal
      width="580px"
      class="question-modal"
      name="forgot-password"
      id="forgot-password-modal"
    >
      <div class="modal-heading">
        <div class="modal-title">
          <h5>Şifreni mi Unuttun?</h5>
        </div>
        <a @click="closeModal()" id="close-forgot-password">
          <base-icon class="close" name="close"></base-icon>
        </a>
      </div>
      <div class="modal-body">
        <span>
          “Veri dağıtım sistemi şifresi, bilgisayar ve mail şifreniz ile aynı
          olarak çalışmaktadır. Şifrenizi unuttuysanız aşağıdaki mail ile
          iletişime geçiniz:”
          <a href="mailto:itdestek@osmanlimenkul.com.tr"
            >itdestek@osmanlimenkul.com.tr</a
          >
        </span>
      </div>
    </modal>
    <div class="wrapper">
      <div class="login-section-left">
        <div class="left-content">
          <base-icon name="logo" />
        </div>
      </div>
      <div class="login-section-right">
        <div class="right-content">
          <div class="title">
            <h6>Giriş Yap</h6>
          </div>
          <div class="body">
            <base-input
              inputType="text"
              labelText="Kullanıcı Adı"
              id="username"
              v-model="username"
              :withIcon="true"
              icon="user"
              @enter="signIn"
            />

            <base-input
              inputType="password"
              labelText="Şifre"
              id="password"
              @enter="signIn"
              v-model="password"
              :withIcon="true"
              icon="password"
            />

            <label v-if="getErrorMsg !== ''" class="error-message">{{
              getErrorMsg
            }}</label>
          </div>

          <div class="footer">
            <base-button
              :isDisabled="!inputsAreIsValid"
              @click="signIn"
              :isLoading="isLoading"
              id="login"
              >Giriş Yap</base-button
            >
            <a @click="showModal()" class="base_link" id="forgot-password-link"
              >Şifremi Unuttum</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.login-page {
  background: var(--color-primary-default);
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  .modal-heading {
    height: 40px;
    border-bottom: 1px solid var(--grayscale-30);
    display: flex;
    align-items: center;
    padding: 15px;
    justify-content: space-between;
    .close {
      margin: 5px;
      cursor: pointer;
    }
  }
  .modal-body {
    padding: 15px;
    span {
      font-size: 14px;
      line-height: 24px;

      a:link,
      a:visited {
        color: var(--body-text);
      }
    }
  }
  .wrapper {
    top: -100px;
    box-shadow: 10px 10px 69px 10px rgba(0, 0, 0, 0.25);
    border-radius: var(--radius-first);
    display: flex;
    flex-direction: row;
    min-width: 840px;
    min-height: 440px;
    position: relative;
    -webkit-animation: slide-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
      both;
    animation: slide-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    @media (max-width: 768px) {
      display: block;
      min-width: 0;
      width: 90%;
    }
    .login-section-left {
      width: 300px;
      min-height: 490px;
      background-color: var(--color-primary-default);
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      @media (max-width: 768px) {
        width: 90%;
        min-height: 120px;
        margin: 0 auto;
      }
      .left-content {
        h1,
        h2 {
          color: var(--grayscale-10);
          line-height: 32pt;
          text-align: center;
        }
      }
    }
    .login-section-right {
      width: 540px;
      min-height: 490px;
      background-color: var(--grayscale-0);
      height: 100%;
      display: flex;
      justify-content: flex-start;
      @media (max-width: 768px) {
        width: 100%;
      }
      .right-content {
        padding: 30px 60px;
        display: flex;
        flex-direction: column;
        width: 100%;
        .title {
          flex: 0.2;
          width: 100%;
          text-align: center;
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
          @media (max-width: 768px) {
            flex: 0.1;
          }
          h6 {
            color: var(--grayscale-80);
          }
        }
        .body {
          flex: 0.6;
          display: flex;
          justify-content: center;
          flex-direction: column;
          height: 100%;
          .base-form-input {
            margin-bottom: 20px;
          }
          .error-message {
            display: flex;
            justify-content: space-between;
            font-size: 13px;
            padding: 20px 10px;
            color: #a0323c;
            background-color: var(--color-accent);
            text-align: left;
            margin-bottom: 20px;
            border-radius: var(--radius-first);
            border: solid 1px rgba(180, 169, 170, 0.1);
          }
        }
        .footer {
          flex: 0.2;
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
          flex-direction: column;

          .base_link {
            margin-top: 20px;
          }
        }
      }
    }
  }
}

/**
 * ----------------------------------------
 * animation slide-bottom
 * ----------------------------------------
 */
@-webkit-keyframes slide-bottom {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(100px);
    transform: translateY(100px);
  }
}
@keyframes slide-bottom {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(100px);
    transform: translateY(100px);
  }
}
</style>
